export default "<app-strip [appType]=\"appType\" [data]=\"data\"></app-strip>";